import React from 'react';
import { CAP_TABLE_SELECTION } from 'pages/Valuations/util/constants';
import {
  ALLOCATION_SCENARIO_TYPE_BACKSOLVE,
  ALLOCATION_SCENARIO_TYPE_FUTURE_EXIT,
  ALLOCATION_SCENARIO_TYPE_SPECIFIED_SHARE_VALUES,
} from 'pages/ValuationsAllocation/common/constants/allocation';
import { CapTableSelectionValueViewer, CapTableVersionSelector } from 'pages/ValuationsAllocation/components';
import { getNumberValue } from 'utilities';
import { HandleCapTableSelectionParams } from './types';

const handleCapTableSelection = (params: HandleCapTableSelectionParams) => {
  const { cell, scenarioType, relatedApproachCaptableSelectionName, capTableVersions } = params;

  cell.dataEditor = props => <CapTableVersionSelector {...props} options={capTableVersions} />;
  cell.dbType = 'number';
  cell.forceComponent = true;
  cell.gridType = 'number';
  cell.isRequired = true;
  cell.customKey = CAP_TABLE_SELECTION;
  cell.valueViewer = props => <CapTableSelectionValueViewer {...props} capTableVersions={capTableVersions} />;

  if (
    [
      ALLOCATION_SCENARIO_TYPE_BACKSOLVE,
      ALLOCATION_SCENARIO_TYPE_FUTURE_EXIT,
      ALLOCATION_SCENARIO_TYPE_SPECIFIED_SHARE_VALUES,
    ].includes(getNumberValue(scenarioType))
  ) {
    cell.isRequired = false;
    cell.readOnly = true;
    if (relatedApproachCaptableSelectionName) {
      cell.expr = `=${relatedApproachCaptableSelectionName}.${CAP_TABLE_SELECTION}`;
    }
  }
};

export default handleCapTableSelection;
